import { Controller } from 'stimulus';
import formatPrice from '@/helpers/formatPrice';

class CartSummaryController extends Controller {
  recalculate() {
    CartSummaryController.getCartSummary()
      .then((res) => {
        const {
          couponValue,
          shippingCosts,
          subTotal,
          totalTax,
          totalWithTax,
        } = res;

        this.updateCartSummary(
          parseFloat(couponValue),
          parseFloat(shippingCosts),
          parseFloat(subTotal),
          parseFloat(totalTax),
          parseFloat(totalWithTax),
        );
      });
  }

  updateCartSummary(
    couponValue,
    shippingCosts,
    subTotal,
    totalTax,
    totalWithTax,
  ) {
    if (this.hasCouponValueTarget) {
      this.couponValueTarget.innerHTML = formatPrice(couponValue);
    }

    if (this.hasShippingCostsTarget) {
      this.shippingCostsTarget.innerHTML = shippingCosts <= 0
        ? window.app.i18n.cartFreeShipping
        : formatPrice(shippingCosts);
    }

    if (this.hasSubTotalTarget) {
      this.subTotalTarget.innerHTML = formatPrice(subTotal);
    }

    if (this.hasTotalTaxTarget) {
      this.totalTaxTarget.innerHTML = formatPrice(totalTax);
    }

    if (this.hasTotalTarget) {
      this.totalTarget.innerHTML = formatPrice(totalWithTax);
    }
  }

  static getCartSummary() {
    return $.ajax({
      url: window.app.api.cartSummary,
      type: 'GET',
    });
  }
}

CartSummaryController.targets = [
  'subTotal',
  'shippingCosts',
  'couponValue',
  'totalTax',
  'total',
];

export default CartSummaryController;
